import { combineReducers } from 'redux';

import cancellationReducer from './ducks/cancellation/reducers';
import orderReducer from './ducks/order/reducers';
import invoicesReducer from './ducks/invoices/reducers';
import plansReducer from './ducks/plans/reducers';
import subscriptionsReducer from './ducks/subscriptions/reducers';
import wizardReducer from './ducks/wizard/reducers';

const reducers = {
  cancellation: cancellationReducer,
  order: orderReducer,
  invoices: invoicesReducer,
  plans: plansReducer,
  subscriptions: subscriptionsReducer,
  wizard: wizardReducer,
};

export default combineReducers(reducers);
